import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, ExplodeIcon } from '@frontend/components';

import { explodedViewTool } from 'modules/common/viewer/cadViewer/data/actions';
import {
  getFocusedBodies,
  getIsExplodedViewActive,
} from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const ExplodedViewTool = ({ isEnabled }) => {
  const dispatch = useDispatch();
  const focusedBodies = useSelector(getFocusedBodies);
  const isActive = useSelector(getIsExplodedViewActive);

  return focusedBodies && focusedBodies.length === 1 && isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Exploded View"
          secondLine="Explode one level deep of the active assembly using the slider"
        />
      }
    >
      <ViewerButton
        isActive={isActive}
        onClick={() => dispatch(explodedViewTool.toggle())}
      >
        <ExplodeIcon boxSize={2.5} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default ExplodedViewTool;
